import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";

// 重复路由报错处理
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

export const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
});
